exports.hubSizes = {
  'XS': 0.01,
  'S': 0.2,
  'M': 0.3,
  'L': 0.4,
  'XL': 0.5,
  'XXL': 0.6
};
